export default "__VITE_ASSET__PMAyH7Iz__"